export default "__VITE_ASSET__C3s4hpF2__"